(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eventto-catalogo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eventto-catalog')) {
  customElements.define('eventto-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.setAttribute('data-enhanced', '');
      this.mobile = window.matchMedia('(max-width: 989px)');
      const backdrop = document.createElement('div');
      backdrop.className = 'ec-filter-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.append(backdrop);
      this.backdrop = backdrop;
      const closePanel = () => this.setPanelOpen(false);
      const onKey = event => { if (event.key === 'Escape' && this.querySelector('[data-panel]')?.open && this.mobile.matches) { closePanel(); this.querySelector('.ec-filter-toggle')?.focus(); } };
      backdrop.addEventListener('click', closePanel);
      document.addEventListener('keydown', onKey);
      const configurePanel = () => { const panel = this.querySelector('[data-panel]'); if (panel) panel.open = !this.mobile.matches; this.mobilePanelOpen = false; backdrop.classList.remove('is-open'); this.panelAnimation?.cancel(); };
      configurePanel();
      const header = document.querySelector('.section-header:has(.eventto-custom-header)') || document.querySelector('.section-header');
      let offsetFrame = 0;
      let trackUntil = 0;
      const measureHeader = () => {
        offsetFrame = 0;
        const rect = header?.getBoundingClientRect();
        const visible = rect ? Math.max(0, Math.min(rect.height, rect.bottom)) : 0;
        this.style.setProperty('--ec-header-visible', `${visible}px`);
        this.style.setProperty('--ec-offset', `${visible + (this.mobile.matches ? 0 : 16)}px`);
        const column = this.querySelector('.ec-filter-column');
        const bounds = this.querySelector('.ec-catalog__layout')?.getBoundingClientRect();
        this.toggleAttribute('data-stuck', this.mobile.matches && !!column && column.getBoundingClientRect().top <= visible + 1 && this.getBoundingClientRect().top < visible);
        if (bounds) {
          this.style.setProperty('--ec-edge-left', `${Math.max(0,bounds.left)}px`);
          this.style.setProperty('--ec-edge-right', `${Math.max(0,document.documentElement.clientWidth-bounds.right)}px`);
        }
        if (performance.now() < trackUntil) offsetFrame = requestAnimationFrame(measureHeader);
      };
      const scheduleMeasure = () => {
        if (!offsetFrame) offsetFrame = requestAnimationFrame(measureHeader);
      };
      const trackHeader = () => {
        trackUntil = performance.now() + 400;
        scheduleMeasure();
      };
      const headerResize = new ResizeObserver(scheduleMeasure);
      const headerState = new MutationObserver(trackHeader);
      if (header) {
        headerResize.observe(header);
        headerState.observe(header, {attributes:true, attributeFilter:['class', 'style']});
        header.addEventListener('transitionrun', trackHeader);
      }
      window.addEventListener('scroll', scheduleMeasure, {passive:true});
      window.addEventListener('resize', scheduleMeasure);
      this.mobile.addEventListener('change', scheduleMeasure);
      measureHeader();
      const onChange = event => {
        if (!event.target.matches('.ec-filter-content input, .ec-sort select')) return;
        this.submitFilters();
      };
      const onSubmit = event => {
        if (event.target !== this.querySelector('.ec-catalog__layout')) return;
        event.preventDefault();
        if (event.submitter?.closest('.quick-add')) return;
        this.submitFilters();
      };
      const onClick = event => {
        if (this.mobile.matches && event.target.closest('.ec-filter-toggle')) {
          event.preventDefault(); this.setPanelOpen(!this.mobilePanelOpen); return;
        }
        const link = event.target.closest('a[data-catalog-link]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); this.navigate(new URL(link.href), true, link.hasAttribute('data-page'));
      };
      const onPop = () => this.navigate(new URL(location.href), false, false);
      this.addEventListener('change', onChange); this.addEventListener('submit', onSubmit); this.addEventListener('click', onClick);
      window.addEventListener('popstate', onPop); this.mobile.addEventListener('change', configurePanel);
      this.cleanup = () => { this.panelAnimation?.cancel(); backdrop.remove(); document.removeEventListener('keydown', onKey); cancelAnimationFrame(offsetFrame); headerResize.disconnect(); headerState.disconnect(); header?.removeEventListener('transitionrun', trackHeader); window.removeEventListener('scroll', scheduleMeasure); window.removeEventListener('resize', scheduleMeasure); this.mobile.removeEventListener('change', scheduleMeasure); this.abort?.abort(); this.removeEventListener('change', onChange); this.removeEventListener('submit', onSubmit); this.removeEventListener('click', onClick); window.removeEventListener('popstate', onPop); this.mobile.removeEventListener('change', configurePanel); };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
    setPanelOpen(open) {
      const panel = this.querySelector('[data-panel]');
      const content = this.querySelector('.ec-filter-content');
      if (!panel || !content) return;
      this.mobilePanelOpen = open;
      this.panelAnimation?.cancel();
      this.backdrop?.classList.toggle('is-open', open && this.mobile.matches);
      if (open) panel.open = true;
      if (!content.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { panel.open = open; return; }
      const frames = [{opacity:0,transform:'translateY(-8px)'},{opacity:1,transform:'translateY(0)'}];
      const animation = content.animate(open ? frames : [...frames].reverse(), {duration:220,easing:'ease-out'});
      this.panelAnimation = animation;
      animation.onfinish = () => { if (this.panelAnimation === animation) { panel.open = open; this.panelAnimation = null; } };
    }
    submitFilters() {
      const form = this.querySelector('form');
      if (!form.reportValidity()) return;
      const url = new URL(this.dataset.collectionUrl, location.origin);
      const current = new URL(location.href);
      for (const key of ['preview_theme_id', 'view']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      for (const [key, value] of new FormData(form)) if ((key.startsWith('filter.') || key === 'sort_by') && String(value).trim() !== '') url.searchParams.append(key, value);
      url.hash = this.id;
      this.navigate(url, true, false);
    }
    async navigate(url, push, scroll) {
      if (url.origin !== location.origin) return;
      const current = new URL(location.href);
      for (const key of ['preview_theme_id', 'view']) if (!url.searchParams.has(key) && current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      this.abort?.abort(); const abort = new AbortController(); this.abort = abort;
      const active = document.activeElement;
      const focusId = this.contains(active) ? active.id : '';
      const expanded = new Map([...this.querySelectorAll('[data-filter-group]')].map(group => [group.dataset.filterGroup, group.open]));
      this.setAttribute('aria-busy', 'true');
      const request = new URL(url); request.hash = ''; request.searchParams.set('section_id', this.dataset.section);
      try {
        const response = await fetch(request, {signal: abort.signal});
        if (!response.ok) throw new Error('Section request failed');
        const html = await response.text();
        if (abort.signal.aborted || !this.isConnected) return;
        const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('eventto-catalog');
        if (!incoming || incoming.dataset.section !== this.dataset.section) throw new Error('Section missing');
        const currentPanelOpen = this.mobilePanelOpen;
        const currentFilterScroll = this.querySelector(this.mobile.matches ? '.ec-filter-content' : '.ec-filter-column')?.scrollTop || 0;
        this.panelAnimation?.cancel();
        this.innerHTML = incoming.innerHTML;
        this.querySelectorAll('[data-filter-group]').forEach(group => { if (expanded.has(group.dataset.filterGroup)) group.open = expanded.get(group.dataset.filterGroup); });
        const panel = this.querySelector('[data-panel]'); if (panel) panel.open = this.mobile.matches ? (scroll ? false : currentPanelOpen) : true;
        const sidebar = this.querySelector(this.mobile.matches ? '.ec-filter-content' : '.ec-filter-column'); if (sidebar) sidebar.scrollTop = currentFilterScroll;
        this.mobilePanelOpen = this.mobile.matches && !!panel?.open;
        this.backdrop?.classList.toggle('is-open', this.mobilePanelOpen);
        if (push) history.pushState({}, '', url);
        if (scroll) { this.scrollIntoView({block:'start', behavior:'instant'}); this.querySelector('[data-results]')?.focus({preventScroll:true}); }
        else if (focusId) this.querySelector('#' + CSS.escape(focusId))?.focus({preventScroll:true});
      } catch (error) {
        if (!abort.signal.aborted) location.assign(url.href);
      } finally { if (this.abort === abort) this.removeAttribute('aria-busy'); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eventto-desplegables"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('eventto-accordion')){
class EventtoAccordion extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  this.ready=true;this.running=new Map();this.listeners=new AbortController();
  this.addEventListener('click',event=>{
   const summary=event.target.closest('.eva-item > summary');
   if(summary&&this.contains(summary)&&!event.target.closest('a,button,input')){
    event.preventDefault();const detail=summary.parentElement;const state=this.running.get(detail);this.toggle(detail,!(state?state.opening:detail.open));return;
   }
  },{signal:this.listeners.signal});
  this.addEventListener('shopify:block:select',event=>{
   const detail=event.target.closest('.eva-item');
   if(detail&&this.contains(detail)){const active=this.running.get(detail);if(active)active.animation.cancel();this.running.delete(detail);detail.open=true;detail.classList.remove('is-closing');}
  },{signal:this.listeners.signal});
 }
 toggle(detail,opening){
  const panel=detail.querySelector('.eva-panel');if(!panel)return;
  const currentHeight=detail.open?panel.getBoundingClientRect().height:0;
  const previous=this.running.get(detail);if(previous)previous.animation.cancel();
  detail.open=true;detail.classList.toggle('is-closing',!opening);
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||!panel.animate){detail.open=opening;detail.classList.remove('is-closing');this.running.delete(detail);return;}
  const end=opening?panel.scrollHeight:0;
  const animation=panel.animate([{height:currentHeight+'px',opacity:currentHeight?1:0},{height:end+'px',opacity:opening?1:0}],{duration:280,easing:'cubic-bezier(.25,.1,.25,1)',fill:'both'});
  this.running.set(detail,{animation,opening});
  animation.onfinish=()=>{detail.open=opening;detail.classList.remove('is-closing');animation.cancel();this.running.delete(detail);};
 }
 disconnectedCallback(){this.listeners?.abort();for(const entry of this.running?.values()||[])entry.animation.cancel();this.running?.clear();this.ready=false;}
}
customElements.define('eventto-accordion',EventtoAccordion);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eventto-faqs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('eventto-faqs')){
class EventtoFaqs extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  this.ready=true;this.running=new Map();this.listeners=new AbortController();
  this.addEventListener('click',event=>{
   const summary=event.target.closest('.efaq-item > summary');
   if(summary&&this.contains(summary)&&!event.target.closest('a,button,input')){
    event.preventDefault();const detail=summary.parentElement;const state=this.running.get(detail);this.toggle(detail,!(state?state.opening:detail.open));return;
   }
   const link=event.target.closest('.efaq-topic');
   if(link&&this.contains(link)){
    const target=this.querySelector(link.getAttribute('href'));
    if(target){event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});this.activate(link);}
   }
  },{signal:this.listeners.signal});
  this.addEventListener('shopify:block:select',event=>{
   const detail=event.target.closest('.efaq-item');
   if(detail&&this.contains(detail)){const active=this.running.get(detail);if(active)active.animation.cancel();this.running.delete(detail);detail.open=true;detail.classList.remove('is-closing');}
  },{signal:this.listeners.signal});
  const groups=[...this.querySelectorAll('.efaq-group')];
  this.updateActive=()=>{
   const edge=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))||80;
   let current=groups[0];for(const group of groups){if(group.getBoundingClientRect().top<=edge+130)current=group;}
   if(current)this.activate(this.querySelector('.efaq-topic[href="#'+current.id+'"]'));
  };
  let queued=false;
  addEventListener('scroll',()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;this.updateActive();});},{passive:true,signal:this.listeners.signal});
  this.updateActive();
 }
 activate(link){
  if(!link)return;for(const item of this.querySelectorAll('.efaq-topic')){item.classList.toggle('is-active',item===link);if(item===link)item.setAttribute('aria-current','location');else item.removeAttribute('aria-current');}
 }
 toggle(detail,opening){
  const panel=detail.querySelector('.efaq-panel');if(!panel)return;
  const currentHeight=detail.open?panel.getBoundingClientRect().height:0;
  const previous=this.running.get(detail);if(previous)previous.animation.cancel();
  detail.open=true;detail.classList.toggle('is-closing',!opening);
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||!panel.animate){detail.open=opening;detail.classList.remove('is-closing');this.running.delete(detail);return;}
  const end=opening?panel.scrollHeight:0;
  const animation=panel.animate([{height:currentHeight+'px',opacity:currentHeight?1:0},{height:end+'px',opacity:opening?1:0}],{duration:280,easing:'cubic-bezier(.25,.1,.25,1)',fill:'both'});
  this.running.set(detail,{animation,opening});
  animation.onfinish=()=>{detail.open=opening;detail.classList.remove('is-closing');animation.cancel();this.running.delete(detail);};
 }
 disconnectedCallback(){this.listeners?.abort();for(const entry of this.running?.values()||[])entry.animation.cancel();this.running?.clear();this.ready=false;}
}
customElements.define('eventto-faqs',EventtoFaqs);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eventto-home-carrusel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eventto-home-carousel')) {
  customElements.define('eventto-home-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.arrows = this.querySelector('.ev-hc__arrows');
      this.footer = this.querySelector('.ev-hc__footer');
      this.status = this.querySelector('[data-status]');
      this.dots = this.querySelector('[data-dots]');
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.dots.addEventListener('click', event => {
        const dot = event.target.closest('[data-index]');
        if (!dot || !this.dots.contains(dot)) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollTo({left: Number(dot.dataset.index) * this.step() * (rtl ? -1 : 1), behavior: this.behavior()});
      }, options);
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), {...options, passive: true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({left: event.key === 'Home' ? 0 : this.track.scrollWidth * (rtl ? -1 : 1), behavior: this.behavior()});
        }
      }, options);
      this.observer = new ResizeObserver(() => this.scheduleUpdate());
      this.observer.observe(this.track);
      this.setAttribute('data-enhanced', '');
      this.update();
      if ('IntersectionObserver' in window) {
        this.preloadObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.preloadImages();
        }, {rootMargin: '800px 0px', threshold: 0});
        this.preloadObserver.observe(this);
      } else {
        this.preloadImages();
      }
      this.addEventListener('pointerdown', () => this.preloadImages(), {...options, passive: true});
      this.addEventListener('focusin', () => this.preloadImages(), options);
    }
    preloadImages() {
      this.preloadObserver?.disconnect();
      this.preloadObserver = null;
      if (this.imagesPrimed) return;
      this.imagesPrimed = true;
      this.track.querySelectorAll('img').forEach(image => {
        image.decoding = 'async';
        image.loading = 'eager';
        if (typeof image.decode === 'function') image.decode().catch(() => {});
      });
    }
    behavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    step() {
      const item = this.track.firstElementChild;
      return item ? item.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0) : 0;
    }
    move(direction) {
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({left: direction * this.step() * (rtl ? -1 : 1), behavior: this.behavior()});
    }
    scheduleUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {this.frame = 0; this.update();});
    }
    update() {
      const width = this.track.clientWidth;
      if (!width) return;
      const max = Math.max(0, this.track.scrollWidth - width);
      const offset = Math.min(max, Math.max(0, Math.abs(this.track.scrollLeft)));
      const overflow = max > 2;
      this.arrows.hidden = !overflow;
      this.footer.hidden = !overflow;
      this.prev.disabled = offset <= 2;
      this.next.disabled = offset >= max - 2;
      const step = this.step();
      const dotCount = step ? Math.max(1, Math.ceil((max - 2) / step) + 1) : 1;
      if (this.dots.children.length !== dotCount) {
        const buttons = Array.from({length: dotCount}, (_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ev-hc__dot';
          button.dataset.index = index;
          button.setAttribute('aria-label', `${this.dots.dataset.label} ${index + 1}`);
          button.setAttribute('aria-controls', this.track.id);
          return button;
        });
        this.dots.replaceChildren(...buttons);
      }
      const activeDot = step ? Math.min(dotCount - 1, Math.round(offset / step)) : 0;
      [...this.dots.children].forEach((button, index) => button.setAttribute('aria-current', String(index === activeDot)));
      const items = [...this.track.children];
      const rect = this.track.getBoundingClientRect();
      const visible = items.map((item,index) => ({index,rect:item.getBoundingClientRect()})).filter(item => item.rect.right > rect.left + 8 && item.rect.left < rect.right - 8);
      if (visible.length) {
        const label = `${visible[0].index + 1}–${visible[visible.length - 1].index + 1} / ${items.length}`;
        if (this.status.textContent !== label) this.status.textContent = label;
      }

    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.preloadObserver?.disconnect();
      this.preloadObserver = null;
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eventto-page-msi"] && !Shopify.designMode) return;
  try {
    


if(!customElements.get('eventto-msi-faqs')){
class EventtoMsiFaqs extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  this.ready=true;this.running=new Map();this.listeners=new AbortController();
  this.addEventListener('click',event=>{
   const summary=event.target.closest('.faq-item > summary');
   if(summary&&this.contains(summary)&&!event.target.closest('a,button,input')){
    event.preventDefault();const detail=summary.parentElement;const state=this.running.get(detail);this.toggle(detail,!(state?state.opening:detail.open));return;
   }
  },{signal:this.listeners.signal});
  this.addEventListener('shopify:block:select',event=>{
   const detail=event.target.closest('.faq-item');
   if(detail&&this.contains(detail)){const active=this.running.get(detail);if(active)active.animation.cancel();this.running.delete(detail);detail.open=true;detail.classList.remove('is-closing');}
  },{signal:this.listeners.signal});
 }
 toggle(detail,opening){
  const panel=detail.querySelector('.faq-panel');if(!panel)return;
  const currentHeight=detail.open?panel.getBoundingClientRect().height:0;
  const previous=this.running.get(detail);if(previous)previous.animation.cancel();
  detail.open=true;detail.classList.toggle('is-closing',!opening);
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||!panel.animate){detail.open=opening;detail.classList.remove('is-closing');this.running.delete(detail);return;}
  const end=opening?panel.scrollHeight:0;
  const animation=panel.animate([{height:currentHeight+'px',opacity:currentHeight?1:0},{height:end+'px',opacity:opening?1:0}],{duration:280,easing:'cubic-bezier(.25,.1,.25,1)',fill:'both'});
  this.running.set(detail,{animation,opening});
  animation.onfinish=()=>{detail.open=opening;detail.classList.remove('is-closing');animation.cancel();this.running.delete(detail);};
 }
 disconnectedCallback(){this.listeners?.abort();for(const entry of this.running?.values()||[])entry.animation.cancel();this.running?.clear();this.ready=false;}
}
customElements.define('eventto-msi-faqs',EventtoMsiFaqs);
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eventto-page-muestras"] && !Shopify.designMode) return;
  try {
    


if(!customElements.get('eventto-sample-faqs')){
class EventtoSampleFaqs extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  this.ready=true;this.running=new Map();this.listeners=new AbortController();
  this.addEventListener('click',event=>{
   const summary=event.target.closest('.evsm-faq > summary');
   if(summary&&this.contains(summary)&&!event.target.closest('a,button,input')){
    event.preventDefault();const detail=summary.parentElement;const state=this.running.get(detail);this.toggle(detail,!(state?state.opening:detail.open));return;
   }
  },{signal:this.listeners.signal});
  this.addEventListener('shopify:block:select',event=>{
   const detail=event.target.closest('.evsm-faq');
   if(detail&&this.contains(detail)){const active=this.running.get(detail);if(active)active.animation.cancel();this.running.delete(detail);detail.open=true;detail.classList.remove('is-closing');}
  },{signal:this.listeners.signal});
 }
 toggle(detail,opening){
  const panel=detail.querySelector('.evsm-faq-panel');if(!panel)return;
  const currentHeight=detail.open?panel.getBoundingClientRect().height:0;
  const previous=this.running.get(detail);if(previous)previous.animation.cancel();
  detail.open=true;detail.classList.toggle('is-closing',!opening);
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||!panel.animate){detail.open=opening;detail.classList.remove('is-closing');this.running.delete(detail);return;}
  const end=opening?panel.scrollHeight:0;
  const animation=panel.animate([{height:currentHeight+'px',opacity:currentHeight?1:0},{height:end+'px',opacity:opening?1:0}],{duration:280,easing:'cubic-bezier(.25,.1,.25,1)',fill:'both'});
  this.running.set(detail,{animation,opening});
  animation.onfinish=()=>{detail.open=opening;detail.classList.remove('is-closing');animation.cancel();this.running.delete(detail);};
 }
 disconnectedCallback(){this.listeners?.abort();for(const entry of this.running?.values()||[])entry.animation.cancel();this.running?.clear();this.ready=false;}
}
customElements.define('eventto-sample-faqs',EventtoSampleFaqs);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-catalogo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hotel-catalog')) {
  customElements.define('hotel-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.setAttribute('data-enhanced', '');
      this.mobile = window.matchMedia('(max-width: 989px)');
      const backdrop = document.createElement('div');
      backdrop.className = 'ht-filter-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.append(backdrop);
      this.backdrop = backdrop;
      const closePanel = () => this.setPanelOpen(false);
      const onKey = event => { if (event.key === 'Escape' && this.querySelector('[data-panel]')?.open && this.mobile.matches) { closePanel(); this.querySelector('.ht-filter-toggle')?.focus(); } };
      backdrop.addEventListener('click', closePanel);
      document.addEventListener('keydown', onKey);
      const configurePanel = () => { const panel = this.querySelector('[data-panel]'); if (panel) panel.open = !this.mobile.matches; this.mobilePanelOpen = false; backdrop.classList.remove('is-open'); this.panelAnimation?.cancel(); };
      configurePanel();
      const header = document.querySelector('.section-header:has(.eventto-custom-header)') || document.querySelector('.section-header');
      let offsetFrame = 0;
      let trackUntil = 0;
      const measureHeader = () => {
        offsetFrame = 0;
        const rect = header?.getBoundingClientRect();
        const visible = rect ? Math.max(0, Math.min(rect.height, rect.bottom)) : 0;
        this.style.setProperty('--ht-header-visible', `${visible}px`);
        this.style.setProperty('--ht-offset', `${visible + (this.mobile.matches ? 0 : 16)}px`);
        const column = this.querySelector('.ht-filter-column');
        const bounds = this.querySelector('.ht-catalog__layout')?.getBoundingClientRect();
        this.toggleAttribute('data-stuck', this.mobile.matches && !!column && column.getBoundingClientRect().top <= visible + 1 && this.getBoundingClientRect().top < visible);
        if (bounds) {
          this.style.setProperty('--ht-edge-left', `${Math.max(0,bounds.left)}px`);
          this.style.setProperty('--ht-edge-right', `${Math.max(0,document.documentElement.clientWidth-bounds.right)}px`);
        }
        if (performance.now() < trackUntil) offsetFrame = requestAnimationFrame(measureHeader);
      };
      const scheduleMeasure = () => {
        if (!offsetFrame) offsetFrame = requestAnimationFrame(measureHeader);
      };
      const trackHeader = () => {
        trackUntil = performance.now() + 400;
        scheduleMeasure();
      };
      const headerResize = new ResizeObserver(scheduleMeasure);
      const headerState = new MutationObserver(trackHeader);
      if (header) {
        headerResize.observe(header);
        headerState.observe(header, {attributes:true, attributeFilter:['class', 'style']});
        header.addEventListener('transitionrun', trackHeader);
      }
      window.addEventListener('scroll', scheduleMeasure, {passive:true});
      window.addEventListener('resize', scheduleMeasure);
      this.mobile.addEventListener('change', scheduleMeasure);
      measureHeader();
      const onChange = event => {
        if (!event.target.matches('input, select')) return;
        this.submitFilters();
      };
      const onSubmit = event => { if (event.target.matches('form')) { event.preventDefault(); this.submitFilters(); } };
      const onClick = event => {
        if (this.mobile.matches && event.target.closest('.ht-filter-toggle')) {
          event.preventDefault(); this.setPanelOpen(!this.mobilePanelOpen); return;
        }
        const link = event.target.closest('a[data-catalog-link]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); this.navigate(new URL(link.href), true, link.hasAttribute('data-page'));
      };
      const onPop = () => this.navigate(new URL(location.href), false, false);
      this.addEventListener('change', onChange); this.addEventListener('submit', onSubmit); this.addEventListener('click', onClick);
      window.addEventListener('popstate', onPop); this.mobile.addEventListener('change', configurePanel);
      this.cleanup = () => { this.panelAnimation?.cancel(); backdrop.remove(); document.removeEventListener('keydown', onKey); cancelAnimationFrame(offsetFrame); headerResize.disconnect(); headerState.disconnect(); header?.removeEventListener('transitionrun', trackHeader); window.removeEventListener('scroll', scheduleMeasure); window.removeEventListener('resize', scheduleMeasure); this.mobile.removeEventListener('change', scheduleMeasure); this.abort?.abort(); this.removeEventListener('change', onChange); this.removeEventListener('submit', onSubmit); this.removeEventListener('click', onClick); window.removeEventListener('popstate', onPop); this.mobile.removeEventListener('change', configurePanel); };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
    setPanelOpen(open) {
      const panel = this.querySelector('[data-panel]');
      const content = this.querySelector('.ht-filter-content');
      if (!panel || !content) return;
      this.mobilePanelOpen = open;
      this.panelAnimation?.cancel();
      this.backdrop?.classList.toggle('is-open', open && this.mobile.matches);
      if (open) panel.open = true;
      if (!content.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { panel.open = open; return; }
      const frames = [{opacity:0,transform:'translateY(-8px)'},{opacity:1,transform:'translateY(0)'}];
      const animation = content.animate(open ? frames : [...frames].reverse(), {duration:220,easing:'ease-out'});
      this.panelAnimation = animation;
      animation.onfinish = () => { if (this.panelAnimation === animation) { panel.open = open; this.panelAnimation = null; } };
    }
    submitFilters() {
      const form = this.querySelector('form');
      if (!form.reportValidity()) return;
      const url = new URL(this.dataset.collectionUrl, location.origin);
      const current = new URL(location.href);
      for (const key of ['preview_theme_id', 'view']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      for (const [key, value] of new FormData(form)) if (String(value).trim() !== '') url.searchParams.append(key, value);
      url.hash = this.id;
      this.navigate(url, true, false);
    }
    async navigate(url, push, scroll) {
      if (url.origin !== location.origin) return;
      const current = new URL(location.href);
      for (const key of ['preview_theme_id', 'view']) if (!url.searchParams.has(key) && current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      this.abort?.abort(); const abort = new AbortController(); this.abort = abort;
      const active = document.activeElement;
      const focusId = this.contains(active) ? active.id : '';
      const expanded = new Map([...this.querySelectorAll('[data-filter-group]')].map(group => [group.dataset.filterGroup, group.open]));
      this.setAttribute('aria-busy', 'true');
      const request = new URL(url); request.hash = ''; request.searchParams.set('section_id', this.dataset.section);
      try {
        const response = await fetch(request, {signal: abort.signal});
        if (!response.ok) throw new Error('Section request failed');
        const html = await response.text();
        if (abort.signal.aborted || !this.isConnected) return;
        const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('hotel-catalog');
        if (!incoming || incoming.dataset.section !== this.dataset.section) throw new Error('Section missing');
        const currentPanelOpen = this.mobilePanelOpen;
        const currentFilterScroll = this.querySelector(this.mobile.matches ? '.ht-filter-content' : '.ht-filter-column')?.scrollTop || 0;
        this.panelAnimation?.cancel();
        this.innerHTML = incoming.innerHTML;
        this.querySelectorAll('[data-filter-group]').forEach(group => { if (expanded.has(group.dataset.filterGroup)) group.open = expanded.get(group.dataset.filterGroup); });
        const panel = this.querySelector('[data-panel]'); if (panel) panel.open = this.mobile.matches ? (scroll ? false : currentPanelOpen) : true;
        const sidebar = this.querySelector(this.mobile.matches ? '.ht-filter-content' : '.ht-filter-column'); if (sidebar) sidebar.scrollTop = currentFilterScroll;
        this.mobilePanelOpen = this.mobile.matches && !!panel?.open;
        this.backdrop?.classList.toggle('is-open', this.mobilePanelOpen);
        if (push) history.pushState({}, '', url);
        if (scroll) { this.scrollIntoView({block:'start', behavior:'instant'}); this.querySelector('[data-results]')?.focus({preventScroll:true}); }
        else if (focusId) this.querySelector('#' + CSS.escape(focusId))?.focus({preventScroll:true});
      } catch (error) {
        if (!abort.signal.aborted) location.assign(url.href);
      } finally { if (this.abort === abort) this.removeAttribute('aria-busy'); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-portada"] && !Shopify.designMode) return;
  try {
    
if (!window.eventtoHotelAnchorReady) {
  window.eventtoHotelAnchorReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('.ht-hero__button[data-hotel-anchor]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById('hotel-marcas') || document.getElementById('hotel-catalogo');
    if (!target) return;
    event.preventDefault();
    const header = document.querySelector('.section-header');
    const desktop = window.matchMedia('(min-width: 990px)').matches;
    const offset = desktop && header ? header.getBoundingClientRect().height + 16 : 16;
    const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
    target.setAttribute('tabindex', '-1');
    target.focus({preventScroll:true});
    window.scrollTo({top, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    const url = new URL(location.href);
    url.hash = target.id;
    history.replaceState(history.state, '', url);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
if (!customElements.get('eventto-related-products')) {
  customElements.define('eventto-related-products', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      this.track = this.querySelector('.ev-rp__track');
      this.items = [...this.querySelectorAll('.ev-rp__item')];
      if (!this.track || !this.items.length) return;
      this.prev = this.querySelector('[data-related-prev]');
      this.next = this.querySelector('[data-related-next]');
      this.arrows = this.querySelector('.ev-rp__arrows');
      this.more = this.querySelector('[data-related-more]');
      this.actions = this.querySelector('.ev-rp__mobile-actions');
      this.shown = Math.min(4, this.items.length);
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.more.addEventListener('click', () => {
        const firstNew = this.items[this.shown];
        this.shown = Math.min(this.shown + 4, this.items.length);
        this.applyMobileVisibility();
        if (this.actions.hidden) {
          firstNew?.querySelector('a[id^="CardLink-"]')?.focus({ preventScroll: true });
        }
      }, options);
      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal: this.abort.signal });
      this.setAttribute('data-enhanced', '');
      this.applyMobileVisibility();
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      const media = this.items[0].querySelector('.card__inner');
      if (media) this.resize.observe(media);
      this.update();
    }
    applyMobileVisibility() {
      this.items.forEach((item, index) => item.toggleAttribute('data-mobile-hidden', index >= this.shown));
      this.actions.hidden = this.shown >= this.items.length;
    }
    update() {
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.arrows.hidden = !overflow;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      const media = this.items[0].querySelector('.card__inner');
      const viewport = this.querySelector('.ev-rp__viewport');
      if (media && viewport) {
        const imageRect = media.getBoundingClientRect();
        this.style.setProperty('--ev-rp-arrow-top', `${imageRect.top - viewport.getBoundingClientRect().top + imageRect.height / 2}px`);
      }
    }
    move(direction) {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = this.items[0].getBoundingClientRect().width + gap;
      if (!step) return;
      this.track.scrollBy({ left: direction * 2 * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
